import {
	useGoalsRightOptional,
	useIsViewer,
} from "web_myplann/Api/Rights/RightsProvider";

export const useCanAddDashboardItem = () => {
	const hasGoalsRight = useGoalsRightOptional();
	const isViewer = useIsViewer();

	return hasGoalsRight && !isViewer;
};
